import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid min-vh-100'>
        <div className='text-center'>
          <div
            className='spinner-border text-primary'
            role='status'
            style={{ width: '3rem', height: '3rem' }}
          >
            <span className='visually-hidden'>Loading...</span>
          </div>
          <div className='mt-3'>
            <h5 className='text-gray-600'>Loading payment details...</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
